import { IMember } from "@wingspanhq/users/dist/lib/interfaces";
import type { onboardingApiSpec } from "@wingspanhq/wingspan-api-types";
import { selectorIsDomesticMember } from "./selectorIsDomesticMember";

export const selectorUseInternationalPayouts = (
  member: IMember,
  monitoredEntity?: onboardingApiSpec.CustomerEntity
) => {
  if (monitoredEntity && monitoredEntity.type === "Business") {
    return monitoredEntity.country !== "US";
  }

  return !selectorIsDomesticMember(member);
};
